exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading-shading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.loading-icon {\n  position: absolute;\n  top: calc(45% - 20px);\n  left: calc(50% - 25px);\n}\n\n.loading-spinner {\n  width: 3rem !important;\n  height: 3rem !important;\n}", ""]);

